















































































import BaseComponent from '@/components/base-component.vue';
import { TranscricaoOcrValidValorParm } from '@/interfaces/transcricao-ocr';
import { valideTranscriptionOcrField } from '@/services/prescription';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Ocr } from './transcription-ocr.vue';

@Component({
  components: {},
})
export default class TranscriptionOcrModal extends BaseComponent {
  @Prop()
  private modalOpen: boolean;
  @Prop()
  private ocr: Ocr;

  private valores: any[] = [];
  private produtos: any[] = [];
  private podeContinuar: boolean = false;

  @Watch('ocr')
  private onOcrChange(ocr: Ocr) {
    if (!ocr) {
      return;
    }
    this.podeContinuar = true;
    this.valores = [];
    this.produtos = [];

    this.addValor(this.valores, 'Unidade:', ocr.nomeUnidade, 'idUnidade', true);
    this.addValor(this.valores, 'Médico:', ocr.idMedico? (ocr.crm + ' - ' +  ocr.nomeMedico) : null, 'idMedico', true);
    this.addValor(this.valores, 'Paciente:', ocr.nomePaciente, 'idPaciente', true);
    let peso = ocr.pesoPaciente ? this.decimalFormatHelper(ocr.pesoPaciente, 3) + ' kg' : null;
    this.addValor(this.valores, 'Peso:', peso, 'pesoPaciente');
    //this.addValor(this.valores, 'Peso Calórico:', ocr.pesoCalorico != null ? ocr.pesoCalorico? 'Sim' : 'Não' : null, 'pesoCalorico');
    this.addValor(this.valores, 'Registro:', ocr.registro, 'registro');
    this.addValor(this.valores, 'Leito:', ocr.leito, 'leito');
    this.addValor(this.valores, 'Bolsas:', ocr.divisaoBolsas, 'divisaoBolsas');
    this.addValor(this.valores, 'Volume Desejado:', ocr.volumeDesejado, 'volumeDesejado');
    this.addValor(this.valores, 'Via Administração:', ocr.viaAdministracao, 'viaAdministracao');
    this.addValor(this.valores, 'Tempo Infusão:', ocr.tempoInfusao, 'tempoInfusao');

    ocr.produtos.forEach((p) => {
      this.addValor(this.produtos, `${p.codigo} - ${p.nome}`, p.quantidade + ' ' + p.nomeUnidadeMedida, 'p-' + p.id, false, 'Nome no arquivo: ' + p.nomeOriginal, true, p.nomeOriginal);
    });
  }

  private addValor(lista, label, valor, campo, obrigatorio = false, title = null, produto=false, nomeOriginal=null) {
    if (!valor && obrigatorio) {
      this.podeContinuar = false;
    }
    let item = {
      label: label,
      valor: valor,
      title: title,
      campo: campo,
      ok: valor ? true : false,
      obrigatorio: obrigatorio,
      validar: (this.podeContinuar || obrigatorio) && !!valor,
      produto: produto,
      nomeOriginal: nomeOriginal
    };
    lista.push(item);

    if (item.validar) {
      this.onOk(item, item.ok);
    }
  }

  private limpar() {
    this.valores = [];
    this.produtos = [];
  }

  public closeForm(): void {
    this.$emit('close', this.ocr);
    this.limpar();
  }

  public confirmar(): void {
    this.$emit('confirm', this.ocr);
    this.limpar();
  }

  public onOk(item, ok) {
    item.ok = ok;
    this.ocr.aprovacaoValores[item.campo] = ok;        
  }

  private enviarValidacao(item, ok): void {
    let valid: TranscricaoOcrValidValorParm = new TranscricaoOcrValidValorParm();
    valid.key = this.ocr.key;
    if (item.produto) {
      valid.campo = item.nomeOriginal;
      valid.valor = item.label + ' - ' + item.valor;  
    }else{
      valid.campo = item.campo;
      valid.valor = item.valor;
    }
    valid.aprovado = ok;
    valideTranscriptionOcrField(valid).subscribe(res=> {});
  }
}
